module.exports = __webpack_public_path__ + "img/re_success.aefe06dc.png";